var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-topprogress',{ref:"topProgress",staticClass:"top-loader",class:_vm.topLoaderClasses,attrs:{"color":_vm.loaderColor}})
}
var staticRenderFns = []

export { render, staticRenderFns }